import FormFieldViewText from "components/FormFields/ViewText";
import TagsList from "components/TagsList";
import FormField from "ds/components/Form/Field";
import useTypedContext from "hooks/useTypedContext";
import tooltips from "shared/Scan/tooltips";

import { ScanSettingsContextData } from "../Context";

const ScanSettingsCloudProviderView = () => {
  const { scanSettings } = useTypedContext(ScanSettingsContextData);

  const providerConfig = scanSettings.providerConfigs[0];
  const regions = scanSettings.providerConfigs.map(({ config }) => config.region);

  return (
    <>
      <FormFieldViewText
        label="Provider version"
        value={providerConfig?.version}
        noMargin
        tooltipInfo={tooltips.PROVIDER_VERSION}
        tooltipInfoVariant="modal"
      />

      <FormFieldViewText
        label="Integration"
        value={providerConfig?.integrationName}
        noMargin
        tooltipInfo={tooltips.INTEGRATION}
        tooltipInfoVariant="modal"
      />

      <FormField label="Regions" noMargin>
        <TagsList tags={regions} alwaysExpanded withEmptyPlaceholder />
      </FormField>
    </>
  );
};

export default ScanSettingsCloudProviderView;
